import { Outlet } from "react-router-dom";

export default function Roles() {
	return (
		<div className='roles-page page'>
			<Outlet />
		</div>
	);
}
